import { styled, spacing, Text, mq } from '@thg-commerce/gravity-theme'

export const TabContainer = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.palette.brand.lightest};
  padding: ${spacing(4)} ${spacing(3)} 0;

  p,
  a {
    margin-bottom: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${spacing(6)} ${spacing(6)} 0;
  }
`

export const SectionContainer = styled.div`
    margin-bottom: ${spacing(4)};
    
    &:last-of-type {
      margin-bottom: ${spacing(4)};
    }

    ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
      margin-bottom: ${spacing(6)};
    }
  }
`

export const Title = styled.h2`
  ${Text('medium1', 'alternate')};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: inline-block;
    margin-right: ${spacing(2)};
  }
`

export const TitleContainer = styled.div`
  margin-bottom: ${spacing(2)};
`

export const Subtitle = styled.span<{
  useSuccessColor?: boolean
}>`
  ${Text('bodyText', 'alternate')};
  ${(props) =>
    props.useSuccessColor &&
    `
      color: ${props.theme.colors.success.base};
    `}
`

export const BoldDescription = styled.p`
  ${Text('bodyText', 'alternate')};
`

export const SecondaryTitle = styled.h3`
  ${Text('bodyText', 'alternate')};
  margin-bottom: ${spacing(1)};

  &:first-of-type {
    margin-top: ${spacing(2)};
  }
`
